import React from "react";

const Following = ({ data }) => {
  return (
    <div>
      {data.map((data, index) => (
        <div className="glass-effect coin-held-card" key={index}>
          <div>
            <div>
              <img src={data.profileImage} alt="Coin" className="picture" />
            </div>
            <div className="text-data">
              <p>{data.fullName}</p>
              <p>
                <span>{data.followers} Followers</span>
              </p>
            </div>
          </div>
          <div>
            {/* <button className="button-purple view-coin">Follow</button> */}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Following;
